import Map from './Map.vue'
import { keepDimensions } from 'macarons-graphs-front/src/dataFilter'
import { toScale } from 'macarons-graphs-front/src/colors'

export default {
  id: 'map',
  label: 'Carte',
  component: Map,
  dimensions: 1,
  multipleMeasure: true,
  adaptater: (data, vue) => {
    if (!vue.measure.length) {
      return []
    }
    const props = {
      secondaryValue: vue.measure.length > 1,
      dimension: vue.dimension[0],
      values: vue.measure,
      y2Formatter: vue.metadata.measures.length > 1 ? vue.buildMeasureFormatter(vue.metadata.measures[1].UniqueName) : null
    }
    if (vue.colorScheme) {
      props.colorScale = toScale(vue.colorScheme)
    }
    vue.buildProps(props)
    return keepDimensions(vue.graph.dimensions, data).map(d => {
      return {
        data: [],
        value: typeof d[vue.measure[0].Name] === 'undefined' ? 0 : parseFloat(
          d[vue.measure[0].Name].replace(',', '.')
        ),
        value2: vue.measure.length > 1 ? (
          typeof d[vue.measure[1].Name] === 'undefined' ? 0 : parseFloat(
            d[vue.measure[1].Name].replace(',', '.')
          )
        ) : null,
        label: d.Group0Caption
      }
    }).filter(d => !vue.noEmpty || d.value)
  }
}



// WEBPACK FOOTER //
// ./src/graphs/Map.js